import { render, staticRenderFns } from "./PasteFormat.vue?vue&type=template&id=1092c97b"
import script from "./PasteFormat.vue?vue&type=script&lang=js"
export * from "./PasteFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports